export const isTreeItemGuard = (item) => {
    return item !== null && typeof item === 'object' && 'data' in item;
};
